import MigrationPending from '@/components/ui/MigrationPending'

export default function ThreePlIndex() {
  return <MigrationPending title="3PL Dashboard" subtitle="3PL view — migration to new stack pending" />
}

ThreePlIndex.layout = MigrationPending.layout
